import styled from 'styled-components'
import { TransparentButton } from 'components/common/common_styles'

const LeftArrow = props =>
  <TransparentButton {...props}>
    <svg width={props.width ?? '40'} height='30' viewBox='0 0 40 30' fill='none' strokeWidth='2.5'>
      <title>Left Arrow</title>
      <Path d='M15,2 L2,15 L15,28' />
      <Path d='M2,15 L38,15' />
    </svg>
  </TransparentButton>

export default LeftArrow

const Path = styled.path`
  stroke: var(--spBlack);

  svg:hover & {
    stroke: var(--gray2);
  }
`
